import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["card", "resultCount", "resultIndex"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getSearchResultClickedEvent } from 'marketplace-ui-tracking/events/marketplace';
import { BreezeBadge, EcosystemCardLarge, InstallBadge, ProductTypeBadge } from 'trellis-ecosystem';
import { getSourceIdByCard } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function StorefrontListingCard(_ref) {
  var _card$description, _card$listingName, _card$providerName;
  let {
      card,
      resultCount,
      resultIndex
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const firstProduct = card.products[0];
  const productType = firstProduct === null || firstProduct === void 0 ? void 0 : firstProduct.productType;
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const onLinkClick = () => {
    trackMarketplaceEvent(getSearchResultClickedEvent({
      listingId: card.listingId,
      resultCount,
      resultIndex,
      resultType: 'LISTING',
      slug: card.slug,
      sourceId: getSourceIdByCard(card),
      type: productType
    }));
  };
  return /*#__PURE__*/_jsx(EcosystemCardLarge, Object.assign({}, props, {
    badgesSlot: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ProductTypeBadge, {
        productType: productType,
        agentType: firstProduct === null || firstProduct === void 0 ? void 0 : firstProduct.agentType
      }), card.products.some(p => p.worksWithBreeze) && /*#__PURE__*/_jsx(BreezeBadge, {}), /*#__PURE__*/_jsx(InstallBadge, {
        installed: firstProduct === null || firstProduct === void 0 ? void 0 : firstProduct.installed,
        installCount: card.installCount
      })]
    }),
    certified: firstProduct === null || firstProduct === void 0 ? void 0 : firstProduct.certified,
    description: (_card$description = card.description) !== null && _card$description !== void 0 ? _card$description : '',
    imageSrcSmall: card.iconUrl,
    linkMode: "react-router",
    listingHref: `/listing/${card.slug}`,
    name: (_card$listingName = card.listingName) !== null && _card$listingName !== void 0 ? _card$listingName : '',
    onLinkClick: onLinkClick,
    providerName: (_card$providerName = card.providerName) !== null && _card$providerName !== void 0 ? _card$providerName :
    // TODO: delete this fallback once BE is populated
    unescapedText('marketplaceStorefront.cards.listingCard.hubspot'),
    ribbonSlot: card.betaStage && /*#__PURE__*/_jsx(Ribbon, {
      position: "left",
      use: "beta",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.cards.listingCard.beta"
      })
    })
  }));
}